<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div
                  class="
                    card card-custom
                    gutter-b
                    bg-transparent
                    shadow-none
                    border-0
                  "
                >
                  <div
                    class="
                      card-header
                      align-items-center
                      border-bottom-dark
                      px-0
                    "
                  >
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                          Создать возврат продажи
                      </h3>
                    </div>
                    <div class="actions">
                        <button v-if="processed" @click="downloadInvoice()"  class="btn btn-dark">Скачать накладную</button>
                        <button  v-if="edit"
                            type="button"
                            class="btn"
                            :class="[{'btn-dark': !processed}, {'btn-danger': processed}]"
                            @click="switchProcess"
                        >
                            {{ processed ? 'Отменить проводку' : 'Провести' }}
                        </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <form>
                      <div class="form-group row">
                        <div class="col-md-12">
                          <label class="text-body">Выбрать продажу</label>
                          <fieldset class="form-group mb-3">
                            <Select2 v-model="sale.order_id" :options="salesOptions" @change="fetchSingleOrder()"/>
                          </fieldset>
                        </div>

                        <div class="col-md-6" v-if="display_sale">
                          <label class="text-body">Склад</label>
                          <fieldset class="form-group mb-3">
                            {{ sale.warehouse.warehouse_name }}
                          </fieldset>
                        </div>
                        <div class="col-md-6" v-if="display_sale">
                          <label class="text-body">Клиент</label>
                          <fieldset class="form-group mb-3">
                            {{
                              sale.customer
                                ? sale.customer.customer_first_name +
                                  " " +
                                  sale.customer.customer_last_name
                                : ""
                            }}
                          </fieldset>
                          <label class="text-body">Стоимость доставки</label>
                          <fieldset class="form-group mb-3">
                              <input type="text" class="form-control bg-white" @change="computeValues()" value="" v-model="sale.shipping_cost"/>
                              <small class="form-text text-danger" v-if="errors.has('shipping_cost')" v-text="errors.get('shipping_cost')" ></small>
                          </fieldset>
                        </div>
                        <div class="col-md-6" v-if="display_sale">
                          <label class="text-body">Дата продажи</label>
                          <fieldset class="form-group mb-3">
                            {{ sale.sale_date }}
                          </fieldset>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-xl-12" v-if="display_table">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div class="col-12" style="padding-left: 0; padding-right: 0">
                      <div class="table-responsive">
                        <table class="table table-striped text-body">
                          <thead>
                            <tr>
                              <th class="border-0 header-heading" scope="col">
                                Название
                              </th>
                                <th class="border-0 header-heading" scope="col">
                                Код
                              </th>
                              <th class="border-0 header-heading" scope="col">
                                Заказанное количество
                              </th>
                              <th class="border-0 header-heading" scope="col">
                                Количество на возврат
                              </th>
                              <th class="border-0 header-heading" scope="col">
                                Цена за шт. с налогом
                              </th>
                              <th class="border-0 header-heading" scope="col">
                                Сумма с налогом
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class=""
                              v-for="(
                                selectedProduct, index
                              ) in selectedProducts"
                            >
                              <td>
                                <input
                                  type="hidden"
                                  :set="
                                    (sale.ordered_qty[index] =
                                      selectedProduct.ordered_qty)
                                  "
                                />
                                {{ selectedProduct.title }}
                              </td>
                                <td>
                                {{ selectedProduct.sku }}
                              </td>

                              <td class="text-center">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Ввести количество"
                                  :value="sale.ordered_qty[index]"
                                  readonly
                                />
                                <small
                                  class="form-text text-danger"
                                  v-if="errors.has('ordered_qty.' + index)"
                                  v-text="errors.get('ordered_qty.' + index)"
                                ></small>
                              </td>

                              <td class="text-center">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Ввести количество"
                                  v-model="selectedProduct.order_return_details.qty"
                                  @change="updateQy($event.target.value, index)"
                                />
                                <small
                                  class="form-text text-danger"
                                  v-if="errors.has('sale_qty.' + index)"
                                  v-text="errors.get('sale_qty.' + index)"
                                ></small>
                              </td>

                              <td class="text-center">
                                  <div class="input-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Ввести цену"
                                                :set="
                                                    (sale.price[index] = selectedProduct.price)
                                            "
                                            v-model="sale.price[index]"
                                            readonly
                                        />
                                        <div class="input-group-append">
                                            <span class="input-group-text" style="border: none;">{{ currencySymbol }}</span>
                                        </div>
                                        <small
                                            class="form-text text-danger"
                                            v-if="errors.has('price.' + index)"
                                            v-text="errors.get('price.' + index)"
                                        ></small>
                                  </div>
                              </td>
                              <td class="text-center">
                                  <div class="input-group">
                                    <input
                                    type="text"
                                    readonly
                                    class="form-control"
                                    placeholder="Ввести цену"
                                    v-model="sale.product_total[index]"
                                    />
                                    <div class="input-group-append">
                                        <span class="input-group-text" style="border: none;">{{ currencySymbol }}</span>
                                    </div>
                                  </div>
                              </td>
                                <td class="text-center" v-if="selectedProducts.length>1">
                                  <span @click="removeProduct(index)">Удалить</span>
                              </td>

                              <input
                                type="hidden"
                                :set="
                                  (sale.product_id[index] =
                                    selectedProduct.product_id)
                                "
                              />
                              <input
                                type="hidden"
                                :set="
                                  (sale.product_name[index] =
                                    selectedProduct.title)
                                "
                              />

                              <input
                                type="hidden"
                                :set="
                                  (sale.product_combination_id[index] =
                                    selectedProduct.product_combination_id)
                                "
                              />
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <small
                                  class="form-text text-danger"
                                  v-if="errors.has('sale_qty')"
                                  v-text="errors.get('sale_qty')"
                                ></small>
                              </td>
                              <td colspan="3">
                                <small
                                  class="form-text text-danger"
                                  v-if="errors.has('price')"
                                  v-text="errors.get('price')"
                                ></small>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-xl-12" v-if="display_table">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div class="row mb-3">
                      <div class="col-12">
                        <label>Примечание</label>
                        <fieldset class="form-group mb-3">
                          <textarea
                            class="form-control"
                            id="label-textarea"
                            rows="6"
                            name="notes"
                            style="height: 130px"
                            spellcheck="false"
                            v-model="sale.desc"
                            readonly
                          ></textarea>
                        </fieldset>
                        <small
                          class="form-text text-danger"
                          v-if="errors.has('desc')"
                          v-text="errors.get('desc')"
                        ></small>
                      </div>
                    </div>
                    <div class="row justify-content-end">
                      <div class="col-12 col-md-3">
                        <div>
                          <table class="table right-table mb-0">
                            <tbody>
                              <tr class="d-flex align-items-center justify-content-between">
                                  <th class="border-0">
                                      <h5 class="font-size-h5 mb-0 font-size-bold text-dark" >Налог:</h5>
                                  </th>
                                  <td class="border-0 justify-content-end d-flex text-black-50 font-size-base" >
                                      {{ (sale.total_tax) }} {{ currencySymbol }}
                                  </td>
                              </tr>
                              <tr class="d-flex align-items-center justify-content-between">
                                  <th class="border-0">
                                      <h5 class="font-size-h5 mb-0 font-size-bold text-dark" >Доставка:</h5>
                                  </th>
                                  <td class="border-0 justify-content-end d-flex text-black-50 font-size-base" >
                                      {{ sale.shipping_cost }} {{ currencySymbol }}
                                  </td>
                              </tr>
                              <tr
                                class="
                                  d-flex
                                  align-items-center
                                  justify-content-between
                                "
                              >

                                <th class="border-0">
                                  <h5
                                    class="
                                      font-size-h5
                                      mb-0
                                      font-size-bold
                                      text-dark
                                    "
                                  >
                                    Итого:
                                  </h5>
                                </th>
                                <td
                                  class="
                                    border-0
                                    justify-content-end
                                    d-flex
                                    text-black-50
                                    font-size-base
                                  "
                                >
                                {{ sale.payable }} {{ currencySymbol }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 d-flex justify-content-end" style="padding-left: 0; padding-right: 0">
                      <button v-if="edit" class="btn btn-primary" @click="updateOrderReturn()">
                        Изменить возврат
                      </button>
                      <button v-else class="btn btn-primary" @click="addOrderReturn()">
                        Создать возврат
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorHandling from "./../../ErrorHandling";
export default {
  data() {
    return {
      salesOptions: [],
      display_form: 0,
      display_sale: 0,
      sale: {
        total_tax: 0,
        order_id: "",
        order_return_details: [],
        product_id: [],
        ordered_qty: [],
        qty: [],
        price: [],
        product_total: [],
        product_name: [],
        product_combination_id: [],
        adjustment: 0,
        shipping_cost: 0,
        payable: 0,
      },
      processed: false,
      product_id: "",
      customIndex: 0,
      display_table: false,
      searchParameter: "",
      sortBy: "id",
      sortType: "ASC",
      limit: 10,
      error_message: "",
      edit: false,
      currency: [],
      actions: false,
      pagination: {},
      request_method: "",
      sales: [],
      warehouses: [],
      customers: [],
      products: [],
      selectedProducts: [],
      order: {},
      orderReturn: {},
      token: [],
      errors: new ErrorHandling(),
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  computed: {
    currencySymbol() {
      return window.appConfig?.currencySymbol || '€';
    }
  },
  methods: {
    fetchCurrency() {
      this.$parent.loading = true;
      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      axios
        .get("/api/admin/currency?is_default=1", config)
        .then((res) => {
          if (res.data.status == "Success") {
            this.currency = res.data.data;
          }
        })
        .finally(() => (this.$parent.loading = false));
    },
    fetchOrders() {
      this.$parent.loading = true;
      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      axios
        .get("/api/admin/order?onlyComplete=1&limit=500&sortBy=id&sortType=DESC", config)
        .then((res) => {
          if (res.data.status == "Success") {
            this.sales = res.data.data;
            this.salesOptions = this.sales.map(sale => ({
              id: sale.order_id,
              text: sale.order_id + ' ' +(sale.opencart_id ? '('+sale.opencart_id+') ':'') + sale.billing_first_name+' '+sale.billing_last_name+' ('+sale.order_price+' '+this.currencySymbol+')'
            }));
            console.log('options')
            console.log(this.salesOptions)
          }
        })
        .finally(() => (this.$parent.loading = false));
    },
    fetchSingleOrder() {
      this.$parent.loading = true;
      axios
        .get(
          "/api/admin/order/" +
            this.sale.order_id +
            "?productDetail=1&customer=1&orderDetail=1",
          this.token
        )
        .then((res) => {
          if (res.data.status == "Success") {
            this.display_sale = true;
            this.selectedProducts = [];
            this.order = res.data.data;
            let data = res.data.data;
            console.log('data')
            console.log(data)
            var arr = {};
            this.sale.due_amount = data.order_price;
            this.sale.amount_paid = data.order_price;
            this.sale.desc = "";
            this.sale.discount =
            data.coupon_amount != null ? data.coupon_amount : 0;
            this.sale.sale_date = data.order_date;
            this.sale.payable = data.shipping_cost;
            this.sale.customer_id = data.customer_id;
            this.sale.warehouse = data.warehouse;
            this.sale.customer = data.customer;
            if(!this.$route.params.id){
              this.sale.shipping_cost = data.shipping_cost;
            }

            this.sale.total_tax = 0;
            // arr.payable =data.detail[0].payable;
            var payable = 0;

            for (var i = 0; i < data.order_detail.length; i++) {
              arr.ordered_qty = data.order_detail[i].product_qty;
              arr.price = data.order_detail[i].product_discount_price_with_tax;
              //payable = data.order_detail[i].product_total;
              arr.payable = payable;
              let product = data.order_detail[i].product;

              arr.order_return_details = {};
              arr.order_return_details.order_detail_id = data.order_detail[i].detail_id;
              arr.order_return_details.price_with_tax = data.order_detail[i].product_price_with_tax;
              arr.order_return_details.discount_price_with_tax = data.order_detail[i].product_discount_price_with_tax;
              arr.order_return_details.discount = data.order_detail[i].product_discount;
              arr.order_return_details.qty = 0;

              arr.product_id = product.product_id;
              arr.product_type = product.product_type;

              if (product.product_type == "simple") {
                arr.title = product.product_title ?? "";
                arr.product_combination_id = null;
                arr.sku = product.product_sku;
                if(this.edit){
                  this.orderReturn.order_return_detail.forEach(return_product => {
                      if(return_product.product.product_id == arr.product_id){
                        arr.order_return_details.id = return_product.id;
                        arr.order_return_details.qty = return_product.product_qty;
                        arr.order_return_details.price_with_tax = return_product.product_price_with_tax;

                        this.selectedProducts.push(arr);
                        this.sale.order_return_details.push(arr.order_return_details);
                      }
                  });
                }else{
                  this.selectedProducts.push(arr);
                  this.sale.order_return_details.push(arr.order_return_details);
                }

                arr = {};
              } else {
                if (product.combination_detail.length > 0) {
                  for (var c = 0; c < product.combination_detail.length; c++) {
                    if (
                      data.order_detail[i].product_combination_id.id ==
                      product.combination_detail[c].product_combination_id
                    ) {
                      arr.product_combination_id =
                        product.combination_detail[c].product_combination_id;
                      var combination_name = "";
                      if (
                        product.combination_detail[c].combination.length > 0
                      ) {
                        for (
                          var j = 0;
                          j < product.combination_detail[c].combination.length;
                          j++
                        ) {
                          if (j == 0) {
                            combination_name =
                              product.combination_detail[c].combination[j]
                                .variation.detail[0].name;
                          } else {
                            combination_name +=
                              "-" +
                              product.combination_detail[c].combination[j]
                                .variation.detail[0].name;
                          }
                          console.log("c=" + c + "j=" + j);
                        }
                      }
                      arr.available_qty =
                        product.combination_detail[c].available_qty;
                      arr.product_id = product.product_id;
                      arr.product_type = product.product_type;
                      arr.title =
                        product.combination_detail.length > 0
                          ? product.product_title +
                            " (" +
                            combination_name +
                            ")"
                          : "";
                    }
                  }
                  if(this.edit){
                    this.orderReturn.order_return_detail.forEach(return_product => {
                        if(return_product.product.product_id == arr.product_id){
                          arr.order_return_details.id = return_product.id;
                          arr.order_return_details.qty = return_product.product_qty;
                          arr.order_return_details.price_with_tax = return_product.product_price_with_tax;

                          this.selectedProducts.push(arr);
                          this.sale.order_return_details.push(arr.order_return_details);
                        }
                    });
                  }else{
                    this.selectedProducts.push(arr);
                    this.sale.order_return_details.push(arr.order_return_details);
                  }

                  arr = {};
                }
              }
            }
            this.display_table = true;
            console.log(this.selectedProducts);
            if(this.$route.params.id){
              this.selectedProducts.forEach((selectedProduct, index) => {
                this.updateQy(selectedProduct.order_return_details.qty, index);
              });
            }
          }
        })
        .finally(() => (this.$parent.loading = false));
    },

    fetchOrderReturnItems(id){
      this.edit = true
      this.$parent.loading = true;
      var url = "/api/admin/order-return/"+id+"?&orderDetail=1";
      axios.get(url, this.token)
      .then((res) => {
        console.log(res.data.data)
        this.orderReturn = res.data.data
        this.sale.order_id = res.data.data.order_id
        this.sale.shipping_cost = res.data.data.shipping_cost
        this.processed = res.data.data.processed,
        this.fetchSingleOrder();
        //this.sale = res.data.data;
      })
      .catch((error) => {

      })
      .finally(() => (this.$parent.loading = false));
    },

    addOrderReturn() {
      this.$parent.loading = true;
      var url = "/api/admin/order-return";
      this.request_method = "post";
      axios[this.request_method](url, this.sale, this.token)
        .then((res) => {
          if (res.data.status == "Success") {
            this.display_form = 0;
            this.sale = {
              order_id: "",
              order_return_details: [],
              product_id: [],
              qty: [],
              price: [],
              product_total: [],
              product_name: [],
              product_combination_id: [],
              adjustment: 0,
            };
            this.selectedProducts = [];
            this.display_sale = this.display_table = false;
            this.errors = new ErrorHandling();
            this.$toaster.success(res.data.message);
          } else {
            this.$toaster.error(res.data.message);
          }
        })
        .catch((error) => {
          this.error_message = "";
          this.errors = new ErrorHandling();
          if (error.response.status == 422) {
            if (error.response.data.status == "Error") {
              this.$toaster.error(error.response.data.message);
            } else {
              this.errors.record(error.response.data.errors);
            }
          } else if (error.response.status == 500) {
            this.$toaster.error(error.response.data.message);
          }
        })
        .finally(() => (this.$parent.loading = false));
    },
    updateOrderReturn(){
      axios.put(`/api/admin/order-return/${this.$route.params.id}`, this.sale, this.token)
      .then(res => {
        this.$toaster.success(res.data.message);
      })
      .catch(error => {
          this.$toaster.error(error.response.data.message);
      })
      .finally(() => (this.$parent.loading = false));
    },

    switchProcess(){
      this.$parent.loading = true;
      const token = localStorage.getItem("token");
      const config = {
          headers: {
              Authorization: `Bearer ${token}`
          }
      };

      axios
          .post(`/api/admin/order-return/${this.$route.params.id}/${this.processed ? 'unprocess' : 'process'}`, {}, this.token)
          .then(res => {
              this.processed = !this.processed;
              this.$toaster.success(res.data.message);
          })
          .catch(error => {
              this.$toaster.error(error.response.data.message);
          })
          .finally(() => (this.$parent.loading = false));
    },

    downloadInvoice () {
        var token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            responseType: 'blob'
        };
        axios.get("/api/admin/order-return/"+this.$route.params.id+"/invoice?processed_at="+this.processed_at, config)
            .then(response => {

                const blob = new Blob([response.data], { type: 'application/pdf' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = 'PPR-'+this.orderReturn.order_id
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
    },
    getCurrencyTitle() {
      return this.currency == null ? "" : "(" + this.currency.title + ")";
    },
    updateQy(value, index) {
      if (value < 1) {
        this.$toaster.error("Данное поле не может быть меньше чем 1");
      }
      if (value > this.sale.ordered_qty[index]) {
        this.$toaster.error(
          "На возврат не может быть больше чем в продаже"
        );
      } else {
        this.sale.order_return_details[index].qty = value;
        this.selectedProducts[index].payable =
          value * this.selectedProducts[index].price;
        this.sale.product_total[index] = this.selectedProducts[index].payable;
        this.computeValues();
      }
    },
    computeValues: function () {
      let productTotal = this.sale.product_total.reduce((accumulator, currentPrice) => accumulator + Number(currentPrice), 0);
      this.sale.payable = (productTotal + Number(this.sale.shipping_cost)).toFixed(2);

      const taxRate = 21; // 21% tax rate

      this.sale.total_tax = (productTotal / (1 + 100 / taxRate)).toFixed(2);;
    },
    removeProduct(index) {
      this.sale.order_return_details.splice(index, 1);
      this.selectedProducts.splice(index, 1);
    }
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.token = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    console.log(this.$route.params.id)
    this.fetchCurrency();
    this.fetchOrders();
    if(this.$route.params.id){
      this.fetchOrderReturnItems(this.$route.params.id)
    }
  },
};
</script>
